export default __webpack_public_path__ + "static/media/grotta.b8e32d02.jpg";